import React from "react";
import styled from "styled-components";

import Header from "./components/Header";
import BuyNowLinks from "./components/BuyNowLinks";
import Trailer from "./components/Trailer";
import MapCarousel from "./components/MapCarousel";

function App() {
  return (
    <WidescreenStyle>
      <SiteWrapper>
        <Header />
        <BuyNowLinks />
        <Trailer />
        <TextWrapper>
          <h2>Welcome To The Island!</h2>
        </TextWrapper>
        <TextWrapper>
          <p>
            Lockheart here and I’ve got some news. First the good, we’ve reached
            my fortress lair, Eden, at Cape Corvo. Now the bad, it seems we
            haven’t seen the last of those incorrigible stowaways and piratical
            creatures. Chop chop, we have work to do, and by we, I mean you.
          </p>
          <p>
            You lot are going places, and I don’t just mean on errands around
            this place. To get your mode of transportation up and running,
            however, I’ll be giving you a set of tasks to complete, stat!
          </p>
        </TextWrapper>
        <MapCarousel />
        <TextWrapper>
          <p>
            I’ll be sending my drone, Rover, into the field to help. Do make
            sure to stay close as these dastardly creatures will impede his
            progress, or worse, destroy him.
          </p>
          <p>
            And while Rover isn’t around I’ll be needing you to collect some
            things and transport them to where they need to be. Did you expect
            Rover would be around to help you with everything? He costs more to
            run than I pay you! And while you're at it, I believe I left a
            flatbread in the oven. Be a dear and bring it to me, mmmm Scrake
            ‘ems, never goes bad. How can it, it starts that way!
          </p>
        </TextWrapper>
        <TextWrapper>
          <h2>Your New Friends!</h2>
        </TextWrapper>
        <ImageContainer>
          <img
            src="https://cosmic-s3.imgix.net/66aa39e0-83fc-11e9-bead-778f412d2033-KF2WepRendersKickinBrassHemoclobber1.jpg"
            alt="Hemoclobber"
          />
        </ImageContainer>
        <TextWrapper>
          <p>
            Have you ever wanted to smack around your fellow mercs to make them
            all better (and perhaps to make your own experience a tad more
            cathartic)? For the overworked and underpaid Medics out there, we
            introduce the Hemoclobber. This beauty is a medical melee weapon
            that combines the technology of the medical syringe with the fun of
            beating things to a pulp. It heals players and poisons Zeds on Light
            Attacks. The Heavy Attack uses ammunition for an extra punch. If you
            strike a Zed or player with it, it will cause an explosion of
            medical gas that damages all Zeds in the explosion radius while
            healing players nearby. We feel confident that both Medics and
            Berserkers will find this multi use Tier 3 weapon a bargain at 1100
            Dosh.
          </p>
        </TextWrapper>
        <ImageContainer>
          <img
            src="https://cosmic-s3.imgix.net/66ad9540-83fc-11e9-8d9d-d596ca6a0823-KF2WepRendersKickinBrassSealSqueal1.jpg"
            alt="Seal Squeal"
          />
        </ImageContainer>
        <TextWrapper>
          <p>
            The Seal Squeal is an explosive semi-automatic harpoon launcher that
            fires explosive laden harpoons. Each one of these lovely rounds are
            wrapped with a timed explosive that can pin zeds to another surface.
            Think of it as gore-geous wall art! They attach themselves to
            anything you may want to go boom.This baby has two detonation modes
            to let you control exactly when the explosions happen. The default
            mode self detonates after 4 seconds. If that's not your style and
            you prefer to play with your prey, the alt-fire let's you control
            the explosion much like C-4. We know what mercs are wondering next.
            All this for the low, low price of 1100 Dosh as a Tier 3 weapon at a
            trader pod near you.
          </p>
        </TextWrapper>
        <TextWrapper>
          <h2>The Return of Objective Mode</h2>
        </TextWrapper>
        <TextWrapper>
          <p>
            Starting with the upcoming Steam Fortress map, this is a mode where
            players will need to “get a move on”, as those objectives won’t
            complete themselves, and the Zeds will keep coming! New to the
            objective types players will experience in these maps are a refined
            and updated “escort” and the brand new “transport” objective, which
            will require players to collect and move mission critical items to
            where they need to be. The full objective type list now includes:
          </p>
          <ul>
            <li>Exterminate</li>
            <li>Hold the Zone</li>
            <li>Operate and Control</li>
            <li>Weld and Repair</li>
            <li>Escort</li>
            <li>Transport</li>
          </ul>
        </TextWrapper>
        <ImageContainer>
          <img
            src="https://cosmic-s3.imgix.net/62e58c50-8713-11e9-b19b-fd251f453ec2-objhud1.jpg"
            alt="Objective Hud"
          />
        </ImageContainer>
        <TextWrapper>
          <p>
            Joining Steam Fortress are two classic Killing Floor 2 maps updated
            for Objective mode: Introducing the objective versions of Outpost
            and Zed Landing. Someone new, Dr. Ogada Buyu, has asked for your
            help in discovering some of Horzine’s darkest secrets... and perhaps
            some of her own along the way, if you dare.
          </p>
        </TextWrapper>
        <ImageContainer>
          <img
            src="https://cosmic-s3.imgix.net/631aa610-8713-11e9-b19b-fd251f453ec2-ObjMenu1.jpg"
            alt="Objective Menu"
          />
        </ImageContainer>
        <ExtraPadding />
        <Copyright>
          <h4 style={{ margin: "15px 0" }}>
            © 2018 Tripwire Interactive - All Rights Reserved
          </h4>
        </Copyright>
      </SiteWrapper>
    </WidescreenStyle>
  );
}

export default App;

const WidescreenStyle = styled.div`
  background: linear-gradient(#5f280b, #9c4c1b, #5f280b);
`;

const SiteWrapper = styled.div`
  max-width: 1920px;
  margin: auto;

  h2,
  p,
  li {
    font-family: "Titillium Web", sans-serif;
    letter-spacing: 1px;
  }
`;

const TextWrapper = styled.div`
  margin: 40px 0;
  padding: 0 20vw;

  .image {
    display: flex;
    justify-content: center;
  }

  img {
    width: 70%;
    height: 70%;
  }

  h2 {
    font-family: "BICUBIK", sans-serif;
    font-size: 38px;
    letter-spacing: 3px;
    text-align: center;
    color: #fde704;
    text-shadow: 1px 1px #000000;
    padding: 5vh 0;
  }

  h3 {
    color: #fde704;
    text-shadow: 1px 1px black;
    text-align: left;
    padding: 5px;
    font-size: 18px;
  }

  a {
    color: #fde704;
    text-decoration: none !important;
  }

  a:hover {
    color: #fde704 !important;
    text-decoration: underline !important;
  }

  p,
  li {
    text-shadow: 1px 1px black;
    font-size: 16px;
    color: white;
    text-align: justify;
  }

  @media (max-width: 1608px) {
    padding: 0 15vw;
  }

  @media (max-width: 1378px) {
    padding: 0 10vw;
  }

  @media (max-width: 650px) {
    margin-bottom: 20px;
    padding: 0 5vw;

    img {
      width: 100%;
      height: 100%;
    }

    h2 {
      font-size: 21px;
      letter-spacing: 2px;
    }

    h3 {
      font-size: 15px !important;
    }

    p,
    li {
      text-align: left;
      font-size: 14px;
    }
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 20vw 20px 20vw;

  img {
    height: 100%;
    width: 100%;
    border: solid;
    border-width: 2px;
    border-color: #960a0d;
  }

  @media (max-width: 800px) {
    padding: 10px 10vw 20px 10vw;
  }

  @media (max-width: 650px) {
    padding: 10px 5vw 20px 5vw;
  }
`;

const ExtraPadding = styled.div`
  height: 7vh;
`;

const Copyright = styled.div`
  background: black;
  color: white;
  text-align: center;
  padding: 10px 0;

  h4 {
    font-size: 18px;
  }

  @media (max-width: 650px) {
    h4 {
      font-size: 14px;
    }
  }
`;
